export default {
    exception_detail_title: "Detalles de la excepción",
    exception_detail_all: "Todos",
    exception_detail_behavior: "Comportamiento",
    exception_detail_categories: "Categorías",
    exception_detail_contacts: "Contactos",
    exception_detail_devices: "Dispositivos",
    exception_detail_drivers: "Conductores",
    exception_detail_users: "Usuarios",
    exception_detail_geofences: "Geocercas",
    exception_detail_Maintenance: "Mantenimiento",
    exception_detail_entity: "Entidad",
    exception_detail_exception_detail: "Detalle de la excepción",
    exception_detail_no_data_available: "No hay datos disponibles",
    exception_detail_created_on: "Creado en",
    exception_detail_message: "Mensaje",
    exception_detail_search_by_message: "Buscar por mensaje",
}